/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Pulse_Badge_NewInputs */

const id_home_pulse_badge_new = /** @type {(inputs: Home_Pulse_Badge_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baru`)
};

const ms_home_pulse_badge_new = /** @type {(inputs: Home_Pulse_Badge_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baharu`)
};

const da_home_pulse_badge_new = /** @type {(inputs: Home_Pulse_Badge_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ny`)
};

const de_home_pulse_badge_new = /** @type {(inputs: Home_Pulse_Badge_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neu`)
};

const en_us2_home_pulse_badge_new = /** @type {(inputs: Home_Pulse_Badge_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New`)
};

const es_es2_home_pulse_badge_new = /** @type {(inputs: Home_Pulse_Badge_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuevo`)
};

const es_mx2_home_pulse_badge_new = /** @type {(inputs: Home_Pulse_Badge_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuevo`)
};

const fil_home_pulse_badge_new = /** @type {(inputs: Home_Pulse_Badge_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bago`)
};

const fr_home_pulse_badge_new = /** @type {(inputs: Home_Pulse_Badge_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouveau`)
};

const it_home_pulse_badge_new = /** @type {(inputs: Home_Pulse_Badge_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuovo`)
};

const hu_home_pulse_badge_new = /** @type {(inputs: Home_Pulse_Badge_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Új`)
};

const nl_home_pulse_badge_new = /** @type {(inputs: Home_Pulse_Badge_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nieuw`)
};

const no_home_pulse_badge_new = /** @type {(inputs: Home_Pulse_Badge_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ny`)
};

const pl_home_pulse_badge_new = /** @type {(inputs: Home_Pulse_Badge_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nowe`)
};

const pt_br2_home_pulse_badge_new = /** @type {(inputs: Home_Pulse_Badge_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novo`)
};

const pt_home_pulse_badge_new = /** @type {(inputs: Home_Pulse_Badge_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novo`)
};

const ro_home_pulse_badge_new = /** @type {(inputs: Home_Pulse_Badge_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nou`)
};

const fi_home_pulse_badge_new = /** @type {(inputs: Home_Pulse_Badge_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uusi`)
};

const sv_home_pulse_badge_new = /** @type {(inputs: Home_Pulse_Badge_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ny`)
};

const vi_home_pulse_badge_new = /** @type {(inputs: Home_Pulse_Badge_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mới`)
};

const tr_home_pulse_badge_new = /** @type {(inputs: Home_Pulse_Badge_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yeni`)
};

const cs_home_pulse_badge_new = /** @type {(inputs: Home_Pulse_Badge_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nový`)
};

const bg_home_pulse_badge_new = /** @type {(inputs: Home_Pulse_Badge_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ново`)
};

const ru_home_pulse_badge_new = /** @type {(inputs: Home_Pulse_Badge_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Новое`)
};

const uk_home_pulse_badge_new = /** @type {(inputs: Home_Pulse_Badge_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нове`)
};

const ar_home_pulse_badge_new = /** @type {(inputs: Home_Pulse_Badge_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جديد`)
};

const hi_home_pulse_badge_new = /** @type {(inputs: Home_Pulse_Badge_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नया`)
};

const th_home_pulse_badge_new = /** @type {(inputs: Home_Pulse_Badge_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ใหม่`)
};

const ja_home_pulse_badge_new = /** @type {(inputs: Home_Pulse_Badge_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新規`)
};

const zh_cn2_home_pulse_badge_new = /** @type {(inputs: Home_Pulse_Badge_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新增`)
};

const zh_hant1_home_pulse_badge_new = /** @type {(inputs: Home_Pulse_Badge_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新增`)
};

const ko_home_pulse_badge_new = /** @type {(inputs: Home_Pulse_Badge_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`새로움`)
};

/**
* | output |
* | --- |
* | "New" |
*
* @param {Home_Pulse_Badge_NewInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const home_pulse_badge_new = /** @type {((inputs?: Home_Pulse_Badge_NewInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Pulse_Badge_NewInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_home_pulse_badge_new(inputs)
	if (locale === "ms") return ms_home_pulse_badge_new(inputs)
	if (locale === "da") return da_home_pulse_badge_new(inputs)
	if (locale === "de") return de_home_pulse_badge_new(inputs)
	if (locale === "en-US") return en_us2_home_pulse_badge_new(inputs)
	if (locale === "es-ES") return es_es2_home_pulse_badge_new(inputs)
	if (locale === "es-MX") return es_mx2_home_pulse_badge_new(inputs)
	if (locale === "fil") return fil_home_pulse_badge_new(inputs)
	if (locale === "fr") return fr_home_pulse_badge_new(inputs)
	if (locale === "it") return it_home_pulse_badge_new(inputs)
	if (locale === "hu") return hu_home_pulse_badge_new(inputs)
	if (locale === "nl") return nl_home_pulse_badge_new(inputs)
	if (locale === "no") return no_home_pulse_badge_new(inputs)
	if (locale === "pl") return pl_home_pulse_badge_new(inputs)
	if (locale === "pt-BR") return pt_br2_home_pulse_badge_new(inputs)
	if (locale === "pt") return pt_home_pulse_badge_new(inputs)
	if (locale === "ro") return ro_home_pulse_badge_new(inputs)
	if (locale === "fi") return fi_home_pulse_badge_new(inputs)
	if (locale === "sv") return sv_home_pulse_badge_new(inputs)
	if (locale === "vi") return vi_home_pulse_badge_new(inputs)
	if (locale === "tr") return tr_home_pulse_badge_new(inputs)
	if (locale === "cs") return cs_home_pulse_badge_new(inputs)
	if (locale === "bg") return bg_home_pulse_badge_new(inputs)
	if (locale === "ru") return ru_home_pulse_badge_new(inputs)
	if (locale === "uk") return uk_home_pulse_badge_new(inputs)
	if (locale === "ar") return ar_home_pulse_badge_new(inputs)
	if (locale === "hi") return hi_home_pulse_badge_new(inputs)
	if (locale === "th") return th_home_pulse_badge_new(inputs)
	if (locale === "ja") return ja_home_pulse_badge_new(inputs)
	if (locale === "zh-CN") return zh_cn2_home_pulse_badge_new(inputs)
	if (locale === "zh-Hant") return zh_hant1_home_pulse_badge_new(inputs)
	return ko_home_pulse_badge_new(inputs)
});
export { home_pulse_badge_new as "home.pulse.badge.new" }